<template>
  <div class="language-switch">
    <div class="language-switch__label">
      <span>{{ $t('language') }}</span>
    </div>
    <div class="language-switch__container">
      <a
        class="language-switch__lang language-switch__lang--it"
        :class="{ 'active': $store.state.lang === 'it' }"
        data-apollo-hover
        data-apollo-hover-animation="scale-center"
        href="/it"
      >
        <span class="mobile-hidden">Italian</span>
        <span class="desktop-hidden">It</span>
      </a>
      <div class="language-switch__separator">
        <span>&nbsp;&nbsp;.&nbsp;&nbsp;</span>
      </div>
      <a
        class="language-switch__lang language-switch__lang--en"
        :class="{ 'active': $store.state.lang === 'en' }"
        data-apollo-hover
        data-apollo-hover-animation="scale-center"
        href="/en"
      >
        <span class="mobile-hidden">English</span>
        <span class="desktop-hidden">En</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LanguageSwitch',
};
</script>

<style lang="scss" scoped>
.language-switch {
  color: $color-dark;
  font-size: rem(22px);
  font-size: $font-size-text;

  display: flex;

  &__label {
    margin-right: calc((100vw / 32) * 1);
    color: $color-gray;
  }

  &__container {
    display: flex;
  }

  &__lang {
    position: relative;
    @extend %bottom-line;
    cursor: pointer;

    &.active {
      &::after {
        transform: scaleX(1);
      }
    }
  }
}
</style>
